// Permission helpers — mirrors backend `permissions.py`
export const ROLES = ["STUDENT", "TEACHER", "SALES", "SUPPORT", "FINANCE", "ADMIN", "SUPER_ADMIN"];

export const hasPerm = (user, perm) => {
  if (!user) return false;
  return (user.permissions || []).includes(perm);
};

export const hasAnyPerm = (user, ...perms) => perms.some((p) => hasPerm(user, p));

export const PERM_LABELS = {
  "user:view": "View users",
  "user:manage": "Manage users / change roles",
  "system:settings": "System settings",
  "student:view": "View students",
  "student:manage": "Manage students",
  "assignment:create": "Create assignments",
  "assignment:grade": "Grade assignments",
  "assignment:submit": "Submit assignments",
  "assignment:view": "View assignments",
  "note:create": "Create notes",
  "note:view": "View notes",
  "class:host": "Host live classes",
  "class:join": "Join live classes",
  "batch:manage": "Manage batches",
  "trial:view": "View trial bookings",
  "trial:manage": "Manage trials",
  "payment:view": "View payments",
  "payment:manage": "Manage payments",
  "finance:reports": "View finance reports",
  "analytics:own": "View own analytics",
  "analytics:all": "View all analytics",
  "mock:take": "Take mock tests",
  "ai:use": "Use AI features",
};
